import { useCallback, useMemo } from "react";
import type { Book } from "../types";
import {
  parseWorkbenchPersona,
  personaFromBookMetadata,
  showPublishAsMilestone,
  showPublishSuite,
  showPublisherPackaging,
  showScoreBlendControls,
  showClientsRoster,
  showSpineMatterInsert,
  type WorkbenchPersona,
  WORKBENCH_PERSONA_LABELS,
  WORKBENCH_PERSONAS,
} from "../../shared/personaMode";

export function useWorkbenchPersona(
  book: Book | null,
  onBookChange?: (updates: Partial<Book>) => void
) {
  const persona = useMemo(
    () =>
      book
        ? personaFromBookMetadata(book.metadata as Record<string, unknown>)
        : parseWorkbenchPersona(undefined),
    [book]
  );

  const setPersona = useCallback(
    (next: WorkbenchPersona) => {
      if (!book || !onBookChange) return;
      onBookChange({
        metadata: { workbenchPersona: next },
      });
    },
    [book, onBookChange]
  );

  return {
    persona,
    setPersona,
    labels: WORKBENCH_PERSONA_LABELS,
    options: WORKBENCH_PERSONAS,
    showPublishSuite: showPublishSuite(persona),
    showPublishAsMilestone: showPublishAsMilestone(persona),
    showSpineMatterInsert: showSpineMatterInsert(persona),
    showScoreBlendControls: showScoreBlendControls(persona),
    showClientsRoster: showClientsRoster(persona),
    showPublisherPackaging: showPublisherPackaging(persona),
  };
}
